import { useRef } from "react";

/**
 * The in-place rename editor: Return commits, Escape cancels, and clicking away
 * commits what is there — a half-finished rename is still the name the person
 * typed. One component for chat tabs, sidebar task rows, the home list and the
 * breadcrumb, so wherever a thing is named it is renamed the same way.
 */
export function InlineRenameField({
  initialValue,
  ariaLabel,
  className = "inline-rename-field",
  onCommit,
  onCancel,
}: {
  initialValue: string;
  ariaLabel: string;
  className?: string;
  onCommit: (value: string) => void;
  onCancel: () => void;
}) {
  const abandoned = useRef(false);
  return (
    <input
      className={className}
      type="text"
      autoFocus
      defaultValue={initialValue}
      aria-label={ariaLabel}
      onFocus={(event) => event.currentTarget.select()}
      onClick={(event) => { event.stopPropagation(); event.preventDefault(); }}
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          onCommit(event.currentTarget.value);
        } else if (event.key === "Escape") {
          event.preventDefault();
          event.stopPropagation();
          abandoned.current = true;
          onCancel();
        }
      }}
      onBlur={(event) => {
        if (abandoned.current) return;
        onCommit(event.currentTarget.value);
      }}
    />
  );
}
